import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getValidations = (status) => {
    return request({
        url: namespace + "/validations/" + status,
        method: "get",
    });
};

export const getValidation = (_id) => {
    return request({
        url: namespace + "/validation/" + _id,
        method: "get",
    });
};

export const askValidation = (payload) => {
    return request({
        url: namespace + "/validation",
        data: payload,
        method: "post",
    });
};
